/* eslint-disable */
import Slider from "../modules/slider"
import Breakpoint from '../modules/breakpoint'

export default el => {
    const slider = el.querySelector(".slider");
    const myslider = new Slider(slider);


    const breakpoint = new Breakpoint(768);
    breakpoint.under = () => {
        myslider.enable();
    }
    breakpoint.above = () => {
        myslider.disable();
    }
}